import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'displayPointsAsWholeNumber',
  initialState: false,
  reducers: {
    setDisplayPointsAsWholeNumber(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisplayPointsAsWholeNumber } = slice.actions;

export default slice.reducer;
